import { render, staticRenderFns } from "./PastEventsPage.vue?vue&type=template&id=34c2a290&scoped=true&lang=pug"
import script from "./PastEventsPage.vue?vue&type=script&lang=js"
export * from "./PastEventsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c2a290",
  null
  
)

export default component.exports